import React from 'react';
import productIcon from '../../assets/image/product.svg';

const ImageRenderer = ({ value }) => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				marginTop: '4px',
			}}
		>
			<img
				src={value !== null && value !== 'null' && value !== undefined ? value : productIcon}
				alt="Product"
				style={{
					width: '34px',
					height: '34px',
					objectFit: 'cover',
					borderRadius: '30px',
					border: '1px solid grey',
				}}
			/>
		</div>
	);
};

export default ImageRenderer;
